import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { getTaskFieldList } from "../tasks/taskFieldList";
import Export from "./export";
import SummaryBar from "./summaryBar";

/*
    Overall summary for task counts
*/

const mapStateToProps = (state) => ({
    totalTasks: state.tasks.counts?.totalCount,
    unassignedTasks: state.tasks.counts?.unassignedTask,
    pastDueDateTaskCount: state.tasks.counts?.dueTasksCount,
    emergencyTasks: state.tasks.counts?.emergencyCount,
    priorityTasks: state.tasks.counts?.priorityCount,
    tasks: state.tasks.tasks,
    filter: state.tasklist.filters,
    followUpTypes: state.followUps ? state.followUps.followUpReasons : [],
});

export const OverallSummary = (props) => {
    const { totalTasks, unassignedTasks, pastDueDateTaskCount, emergencyTasks, priorityTasks, followUpTypes, tasks } = props;
    const intl = useIntl();
    const taskFieldList = getTaskFieldList(intl, followUpTypes);
    const items = [
        {
            caption: <FormattedMessage id="summary.total-tasks" description="overall summary: Total tasks" defaultMessage="Total tasks" />,
            value: totalTasks,
        },
        {
            caption: <FormattedMessage id="summary.unassigned" description="overall summary: Unassigned" defaultMessage="Unassigned" />,
            value: unassignedTasks,
        },
        {
            caption: <FormattedMessage id="summary.past-due" description="overall summary: Past due date" defaultMessage="Past due date" />,
            value: pastDueDateTaskCount,
            className: "red",
        },
        {
            caption: <FormattedMessage id="summary.emergencies" description="overall summary: Emergencies" defaultMessage="Emergencies" />,
            value: emergencyTasks,
            className: "red",
        },
        {
            caption: <FormattedMessage id="summary.priority" description="overall summary: Priority" defaultMessage="Priority" />,
            value: priorityTasks,
            className: "orange",
        },
    ];

    return (
        <SummaryBar
            title={
                <FormattedMessage
                    id="summary.title"
                    description="overall summary: Overall summary title"
                    defaultMessage="Overall{br}summary"
                    values={{
                        br: <br />,
                    }}
                />
            }
            items={items}>
            <div className="overall-summary-header-right">
                <div>
                    <Export data={props.tasks} fieldlist={taskFieldList} filter={props.filter} />
                </div>
            </div>
        </SummaryBar>
    );
};

export default connect(mapStateToProps)(OverallSummary);
